import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import SignaturePad from 'signature_pad';
import { ClientSignatureSubmitInfoModel } from 'src/app/core/models/members/client/client-signature-submit-info.model';
import { ActivatedRoute } from '@angular/router';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent implements OnInit {

  @ViewChild("myCanvasSignature", { static: true, read: ElementRef }) canvasSig: ElementRef | undefined;
  @ViewChild("myCanvasInitials", { static: true, read: ElementRef }) canvasInit: ElementRef | undefined;

  signaturePad: SignaturePad | undefined;
  initialsPad: SignaturePad | undefined;

  @Input() clientSig: ClientSignatureSubmitInfoModel = new ClientSignatureSubmitInfoModel();
  @Input() token?: string;
  @Output() submitted = new EventEmitter<any>(); 

  widthPx = 420;
  heightPx = 300;

  constructor(
    private myFileApiService: MyfileApiService,
    private toasterNotificationService: ToasterNotificationService,
  ) { }

  ngOnInit(): void {

    if (this.canvasSig) {
      this.signaturePad = new SignaturePad(this.canvasSig.nativeElement);
    }
    if (this.canvasInit) {
      this.initialsPad = new SignaturePad(this.canvasInit.nativeElement);
    }
    if (window.innerWidth < 400) {
      this.widthPx = window.innerWidth * 0.9;
      this.heightPx = 300;
    } else if (window.innerWidth < 992) {
      this.widthPx = 400;
      this.heightPx = 300;
    } else if (window.innerWidth < 1200) {
      this.widthPx = 600;
    }
  }

  save() {

    if (!this.signaturePad?.isEmpty() && !this.initialsPad?.isEmpty()) {

      this.clientSig.clientSignature.signature = this.signaturePad?.toDataURL().split(',')[1];
      this.clientSig.clientSignature.signaturePointsString = "["
      this.signaturePad!.toData().forEach(result => {
        result.points.forEach(point => {
          this.clientSig.clientSignature.signaturePointsString += `{"X":${point.x},"Y":${point.y},"IsEmpty":false},`
        })
      })
      this.clientSig.clientSignature.signaturePointsString += "]"
      this.clientSig.clientSignature.signaturePointsString = this.clientSig.clientSignature.signaturePointsString?.replace(",]", "]");

      this.clientSig.clientSignature.initials = this.initialsPad?.toDataURL().split(',')[1];
      this.clientSig.clientSignature.initialsPointsString = "["
      this.initialsPad!.toData().forEach(result => {
        result.points.forEach(point => {
          this.clientSig.clientSignature.initialsPointsString += `{"X":${point.x},"Y":${point.y},"IsEmpty":false},`
        })
      })
      this.clientSig.clientSignature.initialsPointsString += "]"
      this.clientSig.clientSignature.initialsPointsString = this.clientSig.clientSignature.initialsPointsString?.replace(",]", "]");
      if(this.token){
        this.myFileApiService.clientSignatureSubmit(this.token,this.clientSig).subscribe(result => {
          if (result) {
            this.submitted.emit(true);
          }else{
            this.submitted.emit(false);
          }
        });
      }
    }
  }

  clearSig() {
    this.signaturePad!.clear();
  }
  clearInit() {
    this.initialsPad!.clear();
  }
}
